<template>
<section>
  <div>
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >
			<el-form  :inline="true" :model="filters" style="float: right;" >
			<!-- @keyup.enter.native="getMember" -->
				<el-form-item>
                <el-select  v-model="shopId" clearable filterable placeholder="选择或搜索门店" @change="selectChange">
                 <el-option
               v-for="item in options"
               :key="item.Id"
                  :label="item.Name"
               :value="item.Id">
                  </el-option>
                   </el-select>				
                   </el-form-item>
				<el-form-item>
					<el-button  type="primary" v-on:click="save" icon="el-icon-search">保存简介</el-button>
				</el-form-item>		
			</el-form>
		</el-col>
    </div> 
  </br>
  </br>
  </br>
  </br>
  </br>

<div>
     
           <!-- <h1>完整demo</h1> -->
           </br>
    <div id="editor" type="text/plain" style="width:100%;height:100%;"></div>
</div>

</section>
   
</template>
<script>
import {getShopInfor,SaveIntroduction} from '../../api/api';
export default {
    data(){
        return {
                shopId:'',
                introduction:'',
                options:[],
				filters: {
					Name: ''
				},}
    },
    methods:{
     save()
        {
           this.introduction=UE.getEditor('editor').getContent();
        //    this.$message({
		// 							message: this.introduction,
		// 							type: 'success'
		// 						});
           let para={
               TenancyId:this.shopId,
               Introduction:this.introduction
           }
            SaveIntroduction(para).then((res) => {                  
                    let { Success,Msg } = res.data;
								if(Success)
								{																
								this.$message({
									message: Msg,
									type: 'success'
                                });
                               this.refreshModel();
								}
								else
								{
									this.$message({message:Msg,type:'error'});
								}
				})
				 .catch(error=>{
                 alert('网络错误');
                });        
        },
        setContent(isAppendTo) {
        // var arr = [];
        // arr.push("使用editor.setContent('欢迎使用ueditor')方法可以设置编辑器的内容");
        UE.getEditor('editor').setContent("s", isAppendTo);
        // alert(arr.join("\n"));
        },
        getContentTxt() {
        var arr = [];
        arr.push(UE.getEditor('editor').getContentTxt());
        alert(arr.join("\n"));
        },
        getContent() {
        var arr = [];
        arr.push(UE.getEditor('editor').getContent());
        // alert(arr.join("\n"));
        return arr;
        },
        selectChange(event)
        { 
            this.options.forEach(item => {
              if (item.Id==event) {
             this.introduction=item.Introduction;
            //  console.log(this.introduction);
             UE.getEditor('editor').setContent(this.introduction==null?"":this.introduction, false);
              }         
             })         
        },
        refreshModel()
        {
             this.options.forEach(item => {
              if (item.Id==this.shopId) {
             item.Introduction=this.introduction;
            //  console.log(this.introduction);
              }         
             })         
        },
        getShopList()
        {
            let para={}
            getShopInfor(para).then((res) => {                  
                    this.options = res.data;
        var id=this.$route.params.id;
         if(id!=undefined)
         {
             this.shopId=id;
              this.options.forEach(item => {
              if (item.Id==this.shopId) {
             this.introduction=item.Introduction;
             UE.getEditor('editor').setContent(this.introduction==null?"":this.introduction, false);
              }         
             })         
         }
				})
				 .catch(error=>{
                 alert('网络错误');
                });          				
        }
    },
    created()
    {
    // window.location.reload();
        
          UE.delEditor('editor'); 
    },
  	 mounted() {
         
         var ue =UE.getEditor('editor');
         this.getShopList();

         
		}
}
</script>

<style scoped>
    
        /* div{
            width:100%;
        }
    */
</style>





// WEBPACK FOOTER //
// ShopIntroduction.vue?1eb3444c